import { format } from 'date-fns';
import type { VacationRequest, VacationRequestStatus } from '../models/vacation.types';
import { getStatusMetadata } from '../vacations.definitions';

export type VacationOutcomeTone = 'success' | 'danger' | 'warning' | 'neutral';

export interface VacationRequestOutcome {
  label: string;
  tone: VacationOutcomeTone;
  decisionDate: string | null;
  decisionBy: string | null;
  status: VacationRequestStatus;
}

export function resolveRequestOutcome(
  request: VacationRequest | null | undefined
): VacationRequestOutcome | null {
  if (!request) return null;

  const { status, dpApproval, managerApproval, statusChangedAt, requestedAt } =
    request;

  if (status === 'Draft') {
    return null;
  }

  if (status === 'Scheduled' || status === 'OnVacation' || status === 'Completed') {
    return {
      label: 'Aprovada',
      tone: 'success',
      decisionDate: dpApproval.at
        ? format(dpApproval.at.toDate(), 'yyyy-MM-dd')
        : null,
      decisionBy: dpApproval.by || null,
      status,
    };
  }

  if (status === 'Rejected') {
    const rejectedApproval = managerApproval?.status === 'Rejected' ? managerApproval : dpApproval;
    return {
      label: 'Reprovada',
      tone: 'danger',
      decisionDate: rejectedApproval.at
        ? format(rejectedApproval.at.toDate(), 'yyyy-MM-dd')
        : null,
      decisionBy: rejectedApproval.by || null,
      status,
    };
  }

  if (status === 'PendingManager' || status === 'PendingClient' || status === 'PendingDP') {
    return {
      label: 'Em andamento',
      tone: 'warning',
      decisionDate: requestedAt
        ? format(requestedAt.toDate(), 'yyyy-MM-dd')
        : null,
      decisionBy: request.requestedBy || null,
      status,
    };
  }

  if (status === 'PendingCorrection') {
    const metadata = getStatusMetadata(status);
    return {
      label: metadata.label,
      tone: 'warning',
      decisionDate: null,
      decisionBy: null,
      status,
    };
  }

  const metadata = getStatusMetadata(status);
  return {
    label: metadata.label,
    tone: 'neutral',
    decisionDate: null,
    decisionBy: null,
    status,
  };
}
